'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7() {
}
export { $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 as $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 };
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7() {
}
export { $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 as $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 };
$h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype;
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype.decompose__T4__T2 = (function(c) {
  var _1$1 = c.T4__f__1;
  var _1 = c.T4__f__2;
  var _2 = c.T4__f__3;
  var _3 = c.T4__f__4;
  var _2$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(_1, _2, _3);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$1);
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype.compose__O__O__O = (function(a, b) {
  var _2 = b.T3__f__1;
  var _3 = b.T3__f__2;
  var _4 = b.T3__f__3;
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T4(a, _2, _3, _4);
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7.prototype.decompose__O__T2 = (function(c) {
  return this.decompose__T4__T2(c);
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7, "app.tulz.tuplez.Composition_Pri7$$anon$7", ({
  Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7: 1,
  Lapp_tulz_tuplez_Composition: 1
}));
export { $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 as $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$7 };
//# sourceMappingURL=app.tulz.tuplez.-Composition_-Pri7$$anon$7.js.map
